import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon69: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="M2.5 0a.5.5 0 0 1 .437.257l1.527 2.742L18.575 3c.997 0 1.678.984 1.335 1.951l-.05.126-2.982 4.951A2.003 2.003 0 0 1 15.16 11H8.963a1.96 1.96 0 0 1-.514-.068 3.886 3.886 0 0 1-.548 2.278l-.619 1.022c.366.16.675.43.884.767h7.186a1.966 1.966 0 1 1-.293 1.034v-.034h-6.6v.034a1.966 1.966 0 1 1-2.262-1.943l.848-1.398a2.93 2.93 0 0 0 .052-2.911L4.476 5.077l-.742-1.326a.759.759 0 0 1-.029-.057v-.002L2.206 1H.5a.5.5 0 0 1 0-1h2Zm14.525 15.067A.967.967 0 1 0 17.026 17a.967.967 0 0 0-.001-1.933Zm-10.531 0a.966.966 0 1 0 0 1.932.966.966 0 0 0 0-1.932ZM18.575 4 5.021 3.999l.46.826 2.62 4.685c.158.265.429.441.731.481l.131.009h6.197c.352 0 .679-.185.86-.487l2.954-4.896A.438.438 0 0 0 18.575 4Z"
      />
    </Svg>
  )
}
